module.exports = __webpack_public_path__ + "static/img/appriana_pagashi_512px.63895a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appriana_pagashi_512px.png
// module id = vq/T
// module chunks = 1